export const FETCH_CUSTOMER = 'OVID/CUSTOMER/V3/FETCH_CUSTOMER'
export const FETCH_CUSTOMER_ERROR = 'OVID/CUSTOMER/V3/FETCH_CUSTOMER_ERROR'
export const FETCH_CUSTOMER_SUCCESS = 'OVID/CUSTOMER/V3/FETCH_CUSTOMER_SUCCESS'
